<template>
<div class="calculator"> 
    <h3 style="text-align:center;" class="bolder">{{$t("template-stats.title")}}</h3>
    <label for="section">{{$t("template-stats.section-label")}}</label>
    <select class="form-control selector" name="section" id="sectionPicker" v-model="selectedSection" @input="countTextStats(chosenSection)" @change="countTextStats(chosenSection)">
        <option :value="'all'" >{{$t("template-stats.all")}}</option>
        <option v-for="section in allText" :key="section.sectionId" :value="section.sectionId">{{section.sectionName}}</option>
    </select>
    <div class="stat-vars" v-if="selectedSection">
        <p> 
            <span class="lighter">{{$t("template-stats.lix")}}          
                <infobox mid bottom :width="400" > 
                    <span slot="icon" class="info">i</span>
                    <h5>{{$t("template-stats.lix-info.title")}}</h5>
                    <ul>
                        <li> <span class="grade1"> Under 24 </span>{{$t("template-stats.lix-info.grade1")}}</li>
                        <li> <span class="grade2"> 25-34 </span> {{$t("template-stats.lix-info.grade2")}}</li>
                        <li> <span class="grade3"> 35-44 </span> {{$t("template-stats.lix-info.grade3")}}</li>
                        <li> <span class="grade4"> 45-54 </span> {{$t("template-stats.lix-info.grade4")}}</li>
                        <li> <span class="grade5"> Over 55 </span>{{$t("template-stats.lix-info.grade5")}}</li>
                    </ul>
                </infobox>
            </span> 
            <animate-text :class="applyColor()" :number="lixNumberFormatted"/>
        </p> 
        <p> <span class="lighter">{{$t("template-stats.words")}}</span>  <animate-text :number="wordsInText" /> </p>
        <p> <span class="lighter">{{$t("template-stats.chars-w-space")}}</span>   <animate-text :number="allChars" :animateTime="10"/> </p> 
        <p> <span class="lighter">{{$t("template-stats.chars-no-space")}}</span>    <animate-text :number="noSpaceChars" :animateTime="10"/></p>
        <p> 
            <span class="lighter"> <span style="text-transform:uppercase;" >{{$t("template-stats.read-time")}} </span>
                 <infobox mid top :width="400"> 
                    <span slot="icon" class="info">i</span>
                    <h5>{{$t("template-stats.time-disclaimer.title")}}</h5>
                    <span>{{$t("template-stats.time-disclaimer.desc")}}</span>
                </infobox>
            </span> 
            
            <span class="d-flex"> 
                <animate-text :number="Math.floor(readTime.m)" :animateTime="30"/>: <animate-text :addZero="true" :number="readTime.d" :animateTime="30"/> 
            </span>
        </p>
    </div> 
</div>
</template>

<script>
	import SentencePreview from '@/assets/js/sentencePreview.js'
    import EventBus from '@/assets/js/eventBus.js'
    import AnimateText from '@/components/AnimateText.vue'
    import Infobox from '@/components/Infobox'
    export default {
    name: 'TemplateStatsCalculator',
        data () {
                return {
                    wordsInText: "",
                    pointsInText: 0,
                    longWordsInText: null,
                    preview: this.$store.state.sentenceEditorPreview,
                    selectedSection: 'all',
                    lixNumber: null,
                    allChars: null,
                    noSpaceChars: null,
                    readTime: {
                        m: null,
                        d: null
                    }
                }
            },

            props:{
                allText: Array
            },

        methods:{
            countTextStats(section){
                if(this.selectedSection === 'all'){
                   let result = this.allText.map(s => s.sectionText).join('');
                    // console.log(result)
                    let mergedSection = {sectionId: "all", sectionText : result}
                    this.countFunction(mergedSection)
                  }
                else {
                    this.countFunction(section)
                }
            },
            countFunction(section){
                let words;
                words = section.sectionText.split(' ')
                findSpace(words)
                function findSpace(w){
                    if(w.indexOf("") == -1){
                        words = w
                   }
                   else{
                    let removeSpace = w.indexOf("")
                    let remover = w.splice(removeSpace, 1)
                       findSpace(w)  
                   }
                }
                this.wordsInText = words.length;


                let pointCount = (section.sectionText.match(/\./g) || [] ).length
                this.pointsInText = pointCount
                // console.log(pointCount)
                
                let longWords = 0;
                  for(let i = 0; i < words.length; i++){
                    if(words[i].includes(".")){
                        if(words[i].charAt(words[i].length -1) == "."){
                            let removeDot = words[i].substring(0, words[i].length - 1)
                            words[i] = removeDot
                        }
                    }
                    if(words[i].length > 6){
                        longWords++
                            }
                        }

                        this.longWordsInText = longWords

                    this.lixNumber = Math.round((this.wordsInText / this.pointsInText ) + ((this.longWordsInText * 100) / this.wordsInText))
                    this.allChars = section.sectionText.split('').length -1
                    this.noSpaceChars = section.sectionText.replace(/\s+/g, '').length

                    this.countReadingTime()
            },

            applyColor(){
                if(this.lixNumber < 24) return 'grade1'
                if(this.lixNumber < 35 && this.lixNumber > 24) return 'grade2'
                if(this.lixNumber < 45 && this.lixNumber > 34) return 'grade3'
                if(this.lixNumber < 55 && this.lixNumber > 44) return 'grade4'
                if(this.lixNumber > 54) return 'grade5'
            },

            countReadingTime(){
                
                let readingSpeed;
                if(this.lixNumber < 24) readingSpeed = 240
                if(this.lixNumber < 35 && this.lixNumber > 24) readingSpeed = 220
                if(this.lixNumber < 45 && this.lixNumber > 34) readingSpeed = 200
                if(this.lixNumber < 55 && this.lixNumber > 44) readingSpeed = 180
                if(this.lixNumber > 54) readingSpeed = 160

                this.readTime.m = this.wordsInText / readingSpeed;
                this.readTime.d = Math.floor(((this.readTime.m - Math.floor(this.readTime.m)) * 0.6) * 100)
                
                // if(this.readTime.d < 10){
                //     let zerofilled = ('0'+ this.readTime.d).slice(-4);
                //     let numbered = parseFloat(zerofilled, 10)
                //     console.log(numbered)
                //     return this.readTime.d = numbered
                //     }
            },
        },
        computed:{
            //To avoid infinity bug 
            lixNumberFormatted(){
                if(this.lixNumber == Infinity){ return 0 }     
                else return this.lixNumber
            },
            chosenSection(){
                return this.allText.find(a => a.sectionId === this.selectedSection)
            }
        },
        created(){
            this.countTextStats()
        },
        components:{
            AnimateText,
            Infobox
        }
    }  
</script>

<style lang="less">
      .calculator{
         
        label{
            color: var(--charcoal-50);
            padding: 0.375rem 1.75rem 0.375rem 0.75rem;
            margin-bottom: 0;
        }
        #sectionPicker{
           text-transform: uppercase;
           font-size: 14px;

            font-weight: 400;
            border: none;
            border-bottom: 1px solid rgba(143, 151, 156, 0.192);
            border-radius: 0;
           
        }

        .stat-vars {
            display: flex;
            flex-direction: column;
            p{
                padding: 10px 0;
                padding: 10px 0.75rem;
                // padding: 0.375rem 1.75rem 0.375rem 0.75rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid rgba(143, 151, 156, 0.192);

                span{
                     cursor: default;
                }
            }
        }
        .grade1{color: rgb(1, 240, 1);}
        .grade2{color: var(--green);}
        .grade3{color:var(--yellow);}
        .grade4{color: #db4a58;}
        .grade5{color:var(--red);}
       
       .info{
            color: #7e7e7e;
            border: 1px solid #7e7e7e;
            padding:0 6px;
            border-radius: 50% 50%;
            margin-left: 4px;
            text-transform: lowercase;
        }
        .red{
            color: var(--red);
        }
        .green{
            color: var(--green);
        }
      }
</style>